import {
  CONTACTLISTING,
  DASHBOARD,
  PURCHASECREDITNOTE,
  REPORTS,
  SIMPLEPURCHASE,
  SUPPLIER,
  SUPPLIERLISTING,
} from "../Routes/constURL";
import { faker } from "@faker-js/faker";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { FaHome } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { GiMoneyStack } from "react-icons/gi";
import { FaHandshake } from "react-icons/fa";
import { MdInventory } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { MdOutlineSettings } from "react-icons/md";
import { IoMdHelpCircleOutline } from "react-icons/io";

const drawerWidth = 40;
const menuItems = [
  { title: "Dashboard", icon: <FaHome />, link: DASHBOARD },
  {
    title: "Purchase",
    icon: <IoCartOutline />,
    subMenu: [
      { title: "Purchase Order", link: SIMPLEPURCHASE },
      { title: "Service Purchase Order" },
      { title: "Purchase Credit Note", link: PURCHASECREDITNOTE },
      { title: "Purchase History" },
      // {
      //     title: "Suppliers",
      //     submenu: [
      //         { title: "General", link: "" },
      //         { title: "Addresses", link: "" },
      //         { title: "Contacts", link: CONTACTLISTING }, // <== Add the link here
      //         { title: "Default Templates", link: "" }
      //       ]
      // }
    ],
  },
  {
    title: "Sales",
    icon: <GiMoneyStack />,
    subMenu: [
      { title: "Sales Order" },
      { title: "Service Sales Order" },
      { title: "Sales Credit Note" },
      { title: "Sales History" },
      {
        title: "Customers",
        submenu: ["General", "Addresses", "Contacts", "Default Templates"],
      },
      { title: "RMA" },
      { title: "RMA History" },
    ],
  },
  {
    title: "Suppliers",
    icon: <FaHandshake />,
    subMenu: [
      { title: "All Suppliers", link: SUPPLIERLISTING },
      { title: "New Supplier", link: SUPPLIER },
      { title: "Supplier Contacts", link: CONTACTLISTING }, // <== Add the link here
      { title: "Archived Suppliers" },
    ],
  },
  {
    title: "Inventory",
    icon: <MdInventory />,
    subMenu: [
      {
        title: "Product/Service",
        submenu: ["General"],
      },
      {
        title: "Product Group",
        submenu: ["Stock"],
      },
      {
        title: "Stock Adjustment",
        submenu: ["Dimensions"],
      },
      {
        title: "Stock Count",
        submenu: ["Alternative Products"],
      },
      {
        title: "Stock Transfer",
        submenu: ["Suppliers"],
      },
      {
        title: "Inventory Write-off",
        submenu: ["Custom Pricing", "Reorder Points", "Discounts"],
      },
    ],
  },
  {
    title: "Reports",
    icon: <BiSolidReport />,
    link: REPORTS,
    // subMenu: [
    //     { title: "Favourites", link: FAVOURITES },
    //     { title: "Sales Reports", link: SALESREPORT },
    //     { title: "Purchase Reports", link: PURCHASEREPORT },
    //     { title: "Inventory Reports", link: INVENTORYREPORT },
    //     { title: "Financial Reports", link: FINANCIALREPORTS },
    //     { title: "Production Reports", link: PRODUCTIONREPORTS },
    //     { title: "Regulatory Reports", link: REGULATORYREPORTS }
    // ]
  },
  {
    title: "Settings",
    icon: <MdOutlineSettings />,
    subMenu: [
      {
        title: "General Settings",
        // submenu: [
        //     "General Settings",
        //     "Organization",
        //     "Security Settings",
        //     "Financial Settings",
        //     "Product & Measurement Settings",
        //     "Sales Process Customization",
        //     "Rounding Settings",
        //     "Sales Pricing Names",
        //     "Tooltip Settings"
        // ]
      },
      { title: "Users & Roles" },
      { title: "Templates" },
    ],
  },
  {
    title: "Help",
    icon: <IoMdHelpCircleOutline />,
  },
];

const data = [
  {
    id: "1",
    name: "quick_links",
    label: "Quick Links",
    display: true,
    fullWidth: true,
    expanded: true,
    data: [
      { title: "Chart of Accounts", count: 0 },
      { title: "Mapping", count: 0 },
      { title: "Suppliers", count: 0 },
      { title: "Products", count: 0 },
      { title: "Customers", count: 0 },
      { title: "Bank Accounts", count: 0 },
    ],
  },
  {
    id: "2",
    name: "reorder",
    label: "Reorders",
    display: true,
    expanded: false,
  },
  {
    id: "3",
    name: "customer_overview",
    label: "Customer Overview",
    display: true,
    expanded: false,
  },
  {
    id: "4",
    name: "performance_metrics",
    label: "Performance Metrics",
    display: true,
    expanded: false,
  },
  {
    id: "5",
    name: "product_overview",
    label: "Product Overview",
    display: true,
    expanded: false,
  },
  {
    id: "6",
    name: "invoices_and_orders",
    label: "Invoices and Orders",
    display: true,
    expanded: false,
  },
  { id: "7", name: "sales", label: "Sales", display: true, expanded: false },
  {
    id: "8",
    name: "purchases",
    label: "Purchases",
    display: true,
    expanded: false,
  },
];

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItems = (count) =>
  Array.from({ length: count }, (_, k) => ({
    id: `Item ${k + 1}`,
    primary: faker.commerce.productName(),
    secondary: faker.company.catchPhrase(),
  }));
const header = [
  // require('../assets/knowledge.png'),
  // require('../assets/heart.png'),
  <AutoStoriesIcon sx={{ color: "black" }} />,
  <FavoriteBorderIcon sx={{ color: "black" }} />,
  // require('../assets/new.png'),
  <AddCircleOutlineIcon sx={{ color: "black" }} />,
  <NotificationsActiveIcon sx={{ color: "black" }} />,
];

const buttons = ["Collapse all Widgets", "Expand all Widgets", "Reset Layout"];

export const Data = {
  menuItems,
  drawerWidth,
  getItems,
  reorder,
  data,
  header,
  buttons,
};
